import type { ReactNode } from "react";
import { clsx } from "@/src/common/utils/clsx";

interface ChipProps {
	active?: boolean;
	onPress?: () => void;
	children: ReactNode;
	className?: string;
}

/**
 * Filter chip — matches Pencil `Chip` + `Chip/Active`.
 * Use for inline filter selection (Feed categories, Job filters, etc.).
 */
export function Chip({ active = false, onPress, children, className }: ChipProps) {
	const Tag = onPress ? "button" : "span";
	return (
		<Tag
			type={onPress ? "button" : undefined}
			onClick={onPress}
			className={clsx(
				"inline-flex items-center gap-1.5 rounded-pill border px-3 py-1 text-xs font-medium transition-colors",
				active ? "border-primary bg-primary text-primary-foreground" : "border-border bg-background text-foreground hover:bg-surface",
				className,
			)}
		>
			{children}
		</Tag>
	);
}
